import React from 'react';

import {Grid, GridSize} from '@mui/material';
import {Breakpoint} from '@mui/material/styles';

type Props = Partial<Record<Breakpoint, boolean | GridSize>>;

export const Offset = ({xs, sm, md, lg, xl}: Props) => {
   return <Grid item xs={xs} sm={sm} md={md} lg={lg} xl={xl} />;
};
